import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import {ReactiveFormsModule, FormsModule} from '@angular/forms';
import { HttpModule } from '@angular/http';
import { AppComponent } from './app.component';
import {LoginComponent} from "./login/login.component";
import {DashboardComponent} from "./dashboard/dashboard.component";
import {PageComponent} from "./page/page.component";
import {routeConfig, routing} from "./router-config";
import {AuthenticationService} from "./shared/services/authentication/authentication.service";
import {AuthGuardService} from "./shared/services/authentication/auth-guard.service";
import { CustomerComponent } from './customer/customer.component';
import { CalendarComponent } from './calendar/calendar.component';
import { SettingsComponent } from './settings/settings.component';
import {UserStorageService} from "./shared/services/authentication/user-storage.service";
import { CustomerFormComponent } from './customer/customer-form/customer-form.component';
import {
  ValidationInputComponent,
  ValidateOnBlurDirective
} from './shared/components/validation-input/validation-input.component';
import {DataStoreService} from "./shared/services/api/data-store.service";
import { JsonApiModule } from "angular2-jsonapi";
import {SimpleNotificationsModule} from "angular2-notifications";
import {AgmCoreModule} from "@agm/core";
import { CustomerViewComponent } from './customer/customer-view/customer-view.component';
import {CustomerResolverService} from "./customer/customer-resolver.service";
import {ScheduleModule, AutoCompleteModule} from 'primeng/primeng';
import { DayFormatPipe } from './shared/pipes/day-format.pipe';
import { OpeningHourFormComponent } from './shared/components/opening-hour-form/opening-hour-form.component';
import { WaitOnDataComponent } from './shared/components/wait-on-data/wait-on-data.component';
import { DataTableComponent } from './shared/components/data-table/data-table.component';
import { TableColumnDirective } from './shared/components/data-table/table-column.directive';
import { TableColumnLabelDirective } from './shared/components/data-table/table-column-label.directive';
import { TableColumnContentDirective } from './shared/components/data-table/table-column-content.directive';
import { MapComponent } from './map/map.component';
import {GeolocationService} from "./shared/services/geo-location.service";
import { RegisterComponent } from './register/register.component';
import { ServerErrorsComponent } from './shared/components/server-errors/server-errors.component';
import {UploadService} from "./shared/services/http/upload.service";
import {Config} from "../environments/environment";
import { AppointmentDetailComponent } from './appointment/appointment-detail/appointment-detail.component';
import {AppointmentResolverService} from "./appointment/appointment-resolver.service";
import { EditableDivDirective } from './shared/directives/editable.directive';
import { AppointmentCreateComponent } from './appointment/appointment-create/appointment-create.component';
import 'hammerjs';
import { ReportDetailComponent } from './report/report-detail/report-detail.component';
import { ReportListComponent } from './report/report-list/report-list.component';
import { LoadingBarComponent } from './shared/components/loading-bar/loading-bar.component';
import {LoadingStateService} from "./shared/services/loading-state.service";
import {EventsResolverService} from "./calendar/events-resolver.service";
import { FileImportComponent } from './settings/file-import/file-import.component';
import { CategoryComponent } from './settings/category/category.component';
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import { PaginatorComponent } from './shared/components/paginator/paginator.component';
import {PagerService} from "./shared/services/pager.service";
import {CustomReuseStrategy} from "./shared/custom-reuse-strategy";
import {RouteReuseStrategy} from "@angular/router";
import {ReportResolverService} from './report/report-resolver.service';
import {DownloadService} from './shared/services/download-service.service';
import {
  MatAutocompleteModule,
  MatButtonModule, MatCardModule, MatCheckboxModule, MatChipsModule, MatCommonModule, MatDialogModule, MatIconModule,
  MatInputModule, MatListModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule, MatSliderModule,
  MatSlideToggleModule, MatTabsModule
} from "@angular/material";
import {CdkPortalOutlet, PortalModule} from "@angular/cdk/portal";
import { ErrorMessageService } from "./shared/services/error-message.service";

@NgModule({
  declarations: [
    LoginComponent,
    DashboardComponent,
    PageComponent,
    AppComponent,
    CustomerComponent,
    CalendarComponent,
    SettingsComponent,
    CustomerFormComponent,
    ValidationInputComponent,
    ValidateOnBlurDirective,
    CustomerViewComponent,
    DayFormatPipe,
    OpeningHourFormComponent,
    WaitOnDataComponent,
    DataTableComponent,
    TableColumnDirective,
    TableColumnLabelDirective,
    TableColumnContentDirective,
    MapComponent,
    RegisterComponent,
    ServerErrorsComponent,
    AppointmentDetailComponent,
    EditableDivDirective,
    AppointmentCreateComponent,
    ReportDetailComponent,
    ReportListComponent,
    LoadingBarComponent,
    FileImportComponent,
    CategoryComponent,
    PaginatorComponent,
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    routing,
    PortalModule,
    MatInputModule,
    MatListModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatButtonModule,
    MatSlideToggleModule,
    MatAutocompleteModule,
    MatRadioModule,
    MatIconModule,
    MatDialogModule,
    MatCardModule,
    MatCheckboxModule,
    MatTabsModule,
    MatSliderModule,
    MatChipsModule,
    JsonApiModule,
    BrowserAnimationsModule,
    SimpleNotificationsModule.forRoot(),
    ScheduleModule,
    AutoCompleteModule,
    AgmCoreModule.forRoot({
      apiKey: Config.googleMapsApiKey
    })
  ],
  entryComponents: [
    AppointmentCreateComponent
  ],
  providers: [
    DataStoreService,
    AuthenticationService,
    AuthGuardService,
    UserStorageService,
    CustomerResolverService,
    GeolocationService,
    UploadService,
    AppointmentResolverService,
    ReportResolverService,
    LoadingStateService,
    EventsResolverService,
    PagerService,
    DownloadService,
    ErrorMessageService,
    {provide: RouteReuseStrategy, useClass: CustomReuseStrategy},
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/app.module.ts